import { EuiFieldText } from "@elastic/eui";
import { formatTextToPhone, formatTextToLinePhone } from "../../utils";
import { ChangeEventHandler } from "react";

interface Props {
  controlProps: any;
  disabled: boolean;
  isInvalid: boolean;
  name: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  phone: string;
  readOnly: boolean;
  type: string;
}

const PhoneNumberField: React.FC<Props> = ({
  onChange,
  name,
  phone,
  type,
  controlProps,
  isInvalid,
  readOnly,
  disabled,
}) => {
  const formatPhoneFunc = type === "linephone" ? formatTextToLinePhone : formatTextToPhone;
  return (
    <EuiFieldText
      name
      onChange={(e) => {
        return onChange(e);
      }}
      onInput={(e: any) => {
        e.target.value = formatPhoneFunc(e.target.value);
      }}
      type="tel"
      value={phone ? formatPhoneFunc(phone) : ""}
      {...(controlProps || {})}
      disabled={disabled}
      isInvalid={isInvalid}
      readOnly={readOnly || false}
    />
  );
};

export default PhoneNumberField;
